import { TravelerPaxResponse } from '@pax/entities/traveler-pax';
import { User } from '@app/modules/core/interfaces/user';
import { PaxType } from '@booking/entities/pax-type';
import { DocumentData, TravelerItemUI, TravelerRoomUI, Identificators } from '@pax/entities/pax-ui';
import { GetDataIndexConfigUI } from '@pax/entities/default-pax';

export function getDefaultDataIndex(config: GetDataIndexConfigUI): number {
  const isEqualsUserDataIndex = config?.travelers?.findIndex(data => isEqualsUserData(config.user, data));
  if (config.documents?.length && config.isInternationalSearch) {
    const defaultDocument = config.rules?.PAX_DEFAULT_DATA_BY_INTERNATIONAL_DOCUMENT_TYPE;
    const defaultDocumentInfo = config.documents.find(_document => _document.TYPE === defaultDocument);
    if (defaultDocumentInfo) {
      const isEqualsByInternational = config.travelers.findIndex(data => isEqualsUserData(config.user, data) &&
        data.configuration_document_id === defaultDocumentInfo.DOCUMENT_ID);
      return isEqualsByInternational >= 0 ? isEqualsByInternational : isEqualsUserDataIndex;
    } else return isEqualsUserDataIndex;
  } else return isEqualsUserDataIndex;
}

export function getDefaultPaxData(
  defaultData: TravelerPaxResponse, defaultAirline: string, isConfigDefault: boolean = false
): TravelerPaxResponse {
  const documentData = getDocumentData(defaultData);
  const loyaltyCollection = defaultData.loyalty.map(loyalty => ({
    ...loyalty,
    traveler: defaultData._id,
    isSelected: loyalty.airline === defaultAirline
  }));
  return {
    ...defaultData,
    isConfigDefault,
    ...documentData,
    loyalty: [...loyaltyCollection]
  };
}

export function getDocumentData(defaultData: TravelerPaxResponse): DocumentData {
  const defaultDocument = defaultData.documents[0];
  const documentData = defaultData.documentId ? {} as DocumentData : defaultDocument ? {
    configuration_document_id: defaultDocument.type ? Number(defaultDocument.type) : null,
    document_number: defaultDocument.number,
    documentId: defaultDocument._id,
  } : {} as DocumentData;
  return documentData;
}

export function getDefaultDataPassengerUI(entity: TravelerItemUI, documentId: string): TravelerPaxResponse {
  const defaultEntityData = entity ? entity.defaultData : null;
  const defaultData = defaultEntityData && defaultEntityData.documentId === documentId ? null :
    defaultEntityData ? {
      ...defaultEntityData, documents: defaultEntityData.documents.filter(doc => doc._id !== documentId)
    } : null;
  return defaultData;
}

export function getDefaultDataGuestUI(roomItem: TravelerRoomUI, entityId: string, documentId: string,
  isConfigDefault: boolean, guestId: number, userDocumentId: boolean = false): TravelerPaxResponse {
  const id = userDocumentId ? documentId : entityId;
  const property = userDocumentId ? Identificators.DOCUMENT_ID : Identificators.ID;
  const defaultEntityData = roomItem.roomGuests[guestId] ? roomItem.roomGuests[guestId].defaultData : null;
  const defaultData = defaultEntityData && defaultEntityData[property] === id ? null :
    defaultEntityData;
  const documents = defaultEntityData ? userDocumentId ? defaultEntityData.documents.filter(doc => doc._id !== documentId) :
    defaultEntityData.documents : [];
  const defaultSaveData = defaultData ? { ...defaultData, isConfigDefault, documents } : null;
  return defaultSaveData;
}

export function isEqualsUserData(user: User, traveler: TravelerPaxResponse): boolean {
  return traveler.pax_type === PaxType.ADULTS && !!user && user.first_name && user.last_name &&
    user.first_name.toUpperCase().trim().includes(traveler.first_name.toUpperCase().trim()) &&
    user.last_name.toUpperCase().trim().includes(traveler.last_name.toUpperCase().trim());
}
